import { getAggregateError, } from "@bracket/catch";
import type { IBracketStore, } from "@types";
import { getVaultExposure, getVaultMeta, gql, } from "@vault/resolvers";
import type { IdentifiableVaultWithState, } from "../loaded/types";
import { getManagedVaultData, } from "./getManagedVaultData";
import type { ManagedVault, } from "./types";

import type { LoadedManagedVault, } from "@types";

/**
 * Fully instantiate a vault with management data and services available to vault managers.
 * @param {IdentifiableVault} vault - The vault to fetch management data for
 * @returns {Promise<ManagedVault>} A fully instantiated vault with management data
 */
export const getManagedVault = async ( store: IBracketStore, vault: IdentifiableVaultWithState, force = false, ): Promise<LoadedManagedVault> => {

	try {

		if(!force && vault.state === "MANAGEABLE") {
			return vault as ManagedVault;
		}

		const {
			wallet: {
				managed_vaults,
			},
		} = await gql<"MANAGED_VAULT_DATA">("MANAGED_VAULT_DATA", vault.symbol as string);

		const managed_vault = managed_vaults.find(v => v.symbol === vault.symbol);
		if(!managed_vault)
			throw new Error(`failed gaining vault "${vault.symbol}"`);

		const [ mgmt, meta, exposure, ] = await Promise.all([
			getManagedVaultData(store, { ...managed_vault, state: "MANAGEABLE" }),
			getVaultMeta(store, { ...managed_vault, state: "MANAGEABLE" }),
			getVaultExposure(store, { ...managed_vault, state: "MANAGEABLE" }),
		]);

		return {
			state: "MANAGEABLE",
			...managed_vault,
			mgmt,
			meta,
			exposure,
			denomination: managed_vault.denomination,
			wrapper: managed_vault.wrapper,
			schedulable_block: managed_vault.schedulable_block,
			transactions: managed_vault.transactions,
		}

	}
	catch(err) {

		throw getAggregateError(err, `store::getManagedVault failed for vault ${vault.symbol}`);
	}

}
